import React, { useState } from 'react';
import { Modal } from '../../componentLibrary/modal/Modal';
export var AsureCloudAnnouncements = function (_a) {
    var postTitle = _a.postTitle, postDate = _a.postDate, postDetail = _a.postDetail, className = _a.className, modalClassName = _a.modalClassName;
    var _b = useState(false), modalShow = _b[0], setModalShow = _b[1];
    return (React.createElement("article", { className: "ACAnnouncement " + (className || '') },
        React.createElement("h1", { className: "m-0 mb-1", onClick: function () { return setModalShow(true); } }, postTitle),
        React.createElement("time", { dateTime: postDate }, postDate),
        React.createElement("p", { className: "m-0 mt-2", "data-testid": "announcement-detail" },
            postDetail.slice(0, 100),
            " \u2026"),
        React.createElement(Modal, { className: modalClassName, open: modalShow, header: postTitle, onClose: function () { return setModalShow(false); }, hasScrollingContent: true },
            React.createElement("p", { className: "mb-1 modal-date" }, postDate),
            React.createElement("p", null, postDetail))));
};
export default AsureCloudAnnouncements;
//# sourceMappingURL=Announcements.js.map